module.exports = __webpack_public_path__ + "static/media/zoomout.f17c58e4.svg";